import React from 'react';
import { Menu, MenuItemProps, MenuListOnSelect, MenuListOnSelectAll } from '@televet/kibble-ui/build/components/Menu';

interface RoomMenuProps {
  menuItems: MenuItemProps[];
  onSelect: MenuListOnSelect;
  onSelectAll: MenuListOnSelectAll;
}

const RoomMenu = ({ menuItems, onSelect, onSelectAll }: RoomMenuProps): JSX.Element | null => (
  <Menu
    isLazy={true}
    buttonProps={{
      variant: 'ghost',
      leftIconName: 'plus',
      text: 'Add Rooms',
      showRightIcon: false,
      size: 'sm',
    }}
    listProps={{
      isSearchable: true,
      isMultiSelect: true,
      canSelectAll: true,
      menuItems,
      onSelect,
      onSelectAll,
    }}
  />
);

const customComparator = (prevProps: RoomMenuProps, nextProps: RoomMenuProps): boolean =>
  JSON.stringify(prevProps.menuItems) === JSON.stringify(nextProps.menuItems);

export default React.memo(RoomMenu, customComparator);
